import * as React from "react"
const SvgLinkTrigger = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11 8a1 1 0 0 0-1-1H7a5 5 0 1 0 0 10h3a1 1 0 1 0 0-2H7a3 3 0 1 1 0-6h3a1 1 0 0 0 1-1m3-1a1 1 0 1 0 0 2h3a3 3 0 0 1 2.905 2.25 1 1 0 0 0 1.937-.5A5 5 0 0 0 17 7zm3.5 10h-1.55a.46.46 0 0 1-.438-.262.46.46 0 0 1 .038-.513l2.5-3.575q.125-.15.287-.1.163.05.163.25V15h1.55q.3 0 .437.262a.46.46 0 0 1-.037.513l-2.5 3.575q-.125.15-.288.1t-.162-.25z" />
    <path d="M9 11a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z" />
  </svg>
)
export default SvgLinkTrigger
